
(function(template){
    define('vue!basicComponents/messageContainer',[
        "Vue",
        "vuex",
        'helpers',
    ], function(Vue, vuex, helpers) {
        vm = this;
        return {
            name: 'Messages',
            template: template,
            data: function(){
                return {
                    defaultTitles: {
                        'warn': vm.localStrings.messages.attExclaim,
                        'success': vm.localStrings.messages.successExclaim,
                        'error': vm.localStrings.messages.errorExclaim
                    }
                }
            },
            computed: vuex.mapState(['globalMessages']),
            methods: {
                handleRemove: function(id){
                    this.$store.commit('removeGlobalMessage',id);
                }
            },
        };
    });
})('<div class="messages-container"> <div v-for="msg in globalMessages" class="alert" :class="\'alert-\'+msg.type" :key="msg.id"> <button type="button" class="close" @click="handleRemove(msg.id)">&times;</button> <strong class="error-title">{{ msg.title || defaultTitles[msg.type] }}</strong> {{msg.message}} </div> </div>');
